export type SharedLibraryTool = "codes" | "components";

export interface ProjectSessionState {
  readonly authenticated: boolean;
  readonly organizationSelected: boolean;
  readonly projectModelOpen: boolean;
}

export interface SharedLibraryAccess {
  readonly state: "authentication-required" | "organization-required" | "project-model-required" | "available";
  readonly reason: string;
}

export function sharedLibraryAccess(
  tool: SharedLibraryTool,
  session: ProjectSessionState
): SharedLibraryAccess {
  const label = tool === "codes" ? "code" : "component";
  if (!session.authenticated) {
    return {
      state: "authentication-required",
      reason: `Sign in to use ${label} libraries.`
    };
  }
  if (!session.organizationSelected) {
    return {
      state: "organization-required",
      reason: `Choose an organization to use ${label} libraries.`
    };
  }
  if (!session.projectModelOpen) {
    return {
      state: "project-model-required",
      reason: `Open or upload a project model to use ${label} libraries.`
    };
  }
  return {
    state: "available",
    reason: `${label[0]?.toUpperCase() ?? ""}${label.slice(1)} libraries are available for this project model.`
  };
}
